import React from "react";
import { Grid, Paper, Box } from "@material-ui/core";
import { Typography, Avatar } from "@mui/material";

import { callEmsGraphData, setEMSName } from "../../datastore/emslistSlice";
import {
  makeStyles,
  ThemeProvider,
  createTheme,
} from "@material-ui/core/styles";
import PowerIcon from "@mui/icons-material/Battery1Bar";
import { setEMSID } from "../../datastore/actions";

import { grey } from "@mui/material/colors";
import GridImg from "../../assets/ic_shadow_wall.png";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import { styled } from "@mui/material/styles";

const today = new Date().toString();

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const formatDate = () => {
  let yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  let time = today.get;

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  return yyyy + "-" + mm + "-" + dd;
};

const theme = createTheme({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
  },
  paper: {
    padding: 30,
    textAlign: "center",
    color: "secondary",
    whiteSpace: "nowrap",
    marginBottom: 30,
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(32),
      height: theme.spacing(16),
    },
  },
  whitePaper: {
    backgroundColor: grey[50],
  },
  lightgrey: {
    backgroundColor: grey[100],
  },
  customBorder: {
    border: `3px solid ${grey[200]}`,
  },
  customBorderRadius: {
    borderRadius: 100,
  },
}));

export const sendMsgForEMS = (dispatch, userID, emsID, socket) => {
  let data = {
    emsName: emsID,
    timestamp: "2023-08-22 18:00:02.841+00", //today,
  };
  dispatch(callEmsGraphData(data));
  dispatch(setEMSName(emsID));
  dispatch(setEMSID(socket, { emsID: emsID, userID: userID }));
};

const EmsGrid = ({ emsGridData, socket, userID, dispatch }) => {
  const { emsID, checkGrid, emsType, emsSOC, emsHealth, emsLoad } = emsGridData;
  var time = new Date().getTime(); // get your number
  var date = new Date(time); // create Date object
  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={3}
        // id={element}
        style={{ margin: "5px", padding: "5px" }}
      >
        <Grid container spacing={2} direction="column">
          <Grid item className="product-card">
            <Paper
              elevation={5}
              style={checkGrid == "ON" ? greenPaperStyle : redPaperStyle}
            >
              <Grid
                onClick={() => {
                  sendMsgForEMS(dispatch, userID, emsID, socket);
                }}
                item
              >
                <Grid container direction="row" spacing={4}>
                  <Grid item>
                    <Typography variant="h5">EMS: {emsID}</Typography>
                  </Grid>
                  <Grid item>
                    <Avatar
                      sx={{
                        backgroundColor: "success.main",
                        height: 28,
                        width: 28,
                      }}
                    >
                      <PowerIcon />
                    </Avatar>
                  </Grid>
                </Grid>

                <Typography variant="subtitle1">
                  LastUpdate: {date.toString().split(" ")[4]}
                </Typography>
                <Typography variant="subtitle2">
                  {checkGrid} (Grid Status)
                </Typography>
                <Typography variant="subtitle2">
                  {emsType} (EMS Type)
                </Typography>
                <Typography variant="subtitle2">{emsSOC}% (Charged)</Typography>
                <Typography variant="subtitle2">
                  {emsHealth} (Health)
                </Typography>
                <Typography variant="subtitle2">{emsLoad} kW (Load)</Typography>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </ThemeProvider>
  );
};

export const EmsGridCus = ({ emsGridData, socket, userID, dispatch }) => {
  const { emsID, checkGrid, emsType, emsSOC, emsHealth, emsLoad } = emsGridData;
  var time = new Date().getTime(); // get your number
  var date = new Date(time); // create Date object
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={3}
        // id={element}
        style={{ margin: "5px", padding: "5px" }}
      >
        <Grid container spacing={2} direction="column">
          <Grid item className="product-card">
            <Paper
              elevation={5}
              style={checkGrid == "ON" ? greenPaperStyle : redPaperStyle}
            >
              <Grid
                onClick={() => {
                  sendMsgForEMS(dispatch, userID, emsID, socket);
                }}
                item
              >
                <Grid container direction="column" spacing={4}>
                  <Grid item>
                    <Paper className={classes.yellowPaper} elevation={15}>
                      <Box p={1}>
                        <Typography variant="h5">{emsID}</Typography>
                      </Box>
                      <Box p={1}>
                        <img
                          width="120"
                          height="120"
                          src={GridImg}
                          alt="react logo"
                        />
                      </Box>
                      <svg id="line-progress" height="120" width="120">
                        <g class="progress-container">
                          <line
                            x1="0"
                            y1="50%"
                            x2="100%"
                            y2="50%"
                            stroke-width="30"
                          />
                        </g>
                        <g class="progress-content">
                          <line
                            x1="0"
                            y1="50%"
                            x2="100%"
                            y2="50%"
                            stroke="#C2E362"
                            fill="transparent"
                            stroke-dasharray="100%"
                            stroke-dashoffset="30%"
                            stroke-width="28"
                          />
                        </g>
                        <text class="percentage" x="40%" y="55%">
                          50%
                        </text>
                      </svg>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </ThemeProvider>
  );
};

const greenPaperStyle = {
  padding: "5px",
  boxShadow:
    "0px 7px 8px -4px rgb(0 255 0 / 20%), 0px 12px 17px 2px rgb(0 255 0 / 14%), 0px 5px 22px 4px rgb(0 255 0 / 12%)",
  marginBottom: "10px",
};
const PaperStyle = {
  drawerPaper: { background: "blue" },
};
const redPaperStyle = {
  padding: "5px",
  boxShadow:
    "0px 7px 8px -4px rgb(255 0 0 / 20%), 0px 12px 17px 2px rgb(255 0 0 / 14%), 0px 5px 22px 4px rgb(255 0 0 / 12%)",
  marginBottom: "10px",
};

export const EmsGridID = ({ emsGridData, socket, userID, dispatch }) => {
  
  const { emsID, checkGrid, emsType, emsSOC, emsHealth, emsLoad } = emsGridData;

  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);

  var time = new Date().getTime(); // get your number
  var date = new Date(time); // create Date object
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={2} direction="column">
        <Grid item className="product-card">
          <Grid
            onClick={() => {
              sendMsgForEMS(dispatch, userID, emsID, socket);
            }}
            item
          >
            <Grid item>
              <Paper className={classes.lightgrey} elevation={2}>
                <List dense={dense}>
                  <ListItem>
                    <ListItemText
                      secondary={emsID}
                      primary={"PowerCell"}
                    />
                  </ListItem>
                </List>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default EmsGrid;

// <svg height="100" width="100">
//                       <circle
//                         cx="50"
//                         cy="50"
//                         r="40"
//                         stroke="black"
//                         stroke-width="2"
//                         fill="#8CABFF"
//                       />
//                       <text x="39" y="50" fill="white" class="heavy">
//                         {emsID}
//                       </text>
//                     </svg>
